import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 2;
  position: relative;
`;
